import { gql } from 'graphql-tag';

export const SLOTS = gql`
  query slots($filter: SlotFilterInput!) {
    slots(filter: $filter) {
      date
      availableSlots {
        machines
        utcEnd
        utcStart
      }
    }
  }
`;
